// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__-AR4r","title":"NotFoundPage_title__98lzl","errorImage":"NotFoundPage_errorImage__q5ut4","homeButton":"NotFoundPage_homeButton__Sccla"};